/* 车辆管理相关接口 */
import { $post } from '@/api/request'

// 车辆管理列表查询
export function query (data = {}) {
  return $post({
    url: '/compCarInfo/query',
    data
  })
}
// 新增车辆 compCarInfo/add
export function add (data = {}) {
  return $post({
    url: '/compCarInfo/add',
    data
  })
}

// 更新车辆详情
export function update (data = {}) {
  return $post({
    url: '/compCarInfo/update',
    data
  })
}
// 暂存用车申请
export function stagingApply (data = {}) {
  return $post({
    url: '/compApplyCar/stagingApply',
    data
  })
}

// 查询自己创建的 
export function queryMine (data = {}) {
  return $post({
    url: '/compApplyCar/queryMine',
    data
  })
}

// 查询需要我审批的 
export function queryMyAudit (data = {}) {
  return $post({
    url: '/compApplyCar/queryMyAudit',
    data
  })
}
// 查询已经审批的
export function listApplyAudited (data = {}) {
  return $post({
    url: '/compApplyCar/listApplyAudited',
    data
  })
}
// 发起用车申请
export function submitApply (data = {}) {
  return $post({
    url: '/compApplyCar/submitApply',
    data
  })
}

// 获取详情 
export function getApplyDetail (data = {}) {
  return $post({
    url: '/compApplyCar/getApplyDetail',
    data
  })
}
// 申请单催批 
export function sendSmsAuditPersonAgain (data = {}) {
  return $post({
    url: '/compApplyCar/sendSmsAuditPersonAgain',
    data
  })
}
// 用车申请审核
export function audit (data = {}) {
  return $post({
    url: '/compApplyCar/audit',
    data
  })
}
// 用车申请审核
export function auditAndNextUser (data = {}) {
  return $post({
    url: '/compApplyCar/auditAndNextUser',
    data
  })
}
// 结束用车申请
export function stopUse (data = {}) {
  return $post({
    url: '/compApplyCar/stopUse',
    data
  })
}